import * as bootstrap from "bootstrap";

export default {
  mounted(el, binding) {
    // Set title from directive value
    el.setAttribute("title", binding.value || "");

    // Initialize tooltip
    el._tooltip = new bootstrap.Tooltip(el, {
      placement: binding.arg || "top",
      trigger: "hover",
      delay: { show: 25, hide: 25 },
    });
  },

  updated(el, binding) {
    // Update title dynamically
    if (binding.value !== binding.oldValue) {
      el.setAttribute("title", binding.value);
      el._tooltip?.setContent({ ".tooltip-inner": binding.value });
    }
  },

  unmounted(el) {
    // Clean up
    el._tooltip?.dispose();
  },
};
